import { ArrowClockwise, CheckCircle, DownloadSimple, SpinnerGap, Trash } from 'phosphor-react';

function JobsTable({
  jobs,
  formatDateTime,
  truncateFileName,
  statusBadgeClass,
  downloadingJobId,
  retryingJobId,
  deletingJobId,
  handleDownload,
  handleRetryClick,
  handleDeleteJob
}) {
  return (
    <section className="relative z-10 rounded-3xl border border-white/60 bg-white/85 p-6 shadow-xl shadow-brand-100/40 backdrop-blur">
      <h2 className="text-lg font-bold">Recent Jobs</h2>
      <div className="mt-4 max-h-[460px] overflow-auto">
        <table className="w-full min-w-[700px] border-collapse text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-xs uppercase tracking-wide text-slate-500">
              <th className="py-2 pr-3">Created</th>
              <th className="py-2 pr-3">Input</th>
              <th className="py-2 pr-3">Output</th>
              <th className="py-2 pr-3">Status</th>
              <th className="py-2 pr-3">Progress</th>
              <th className="py-2 pr-3">Download</th>
              <th className="py-2 pr-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job) => (
              <tr key={job.id} className="border-b border-slate-100">
                <td className="py-2 pr-3 text-slate-600">{formatDateTime(job.createdAt)}</td>
                <td className="py-2 pr-3" title={job.input?.name || '-'}>
                  {truncateFileName(job.input?.name || '-')}
                </td>
                <td className="py-2 pr-3">{job.output?.format || '-'}</td>
                <td className="py-2 pr-3">
                  <span className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold capitalize ${statusBadgeClass(job.status)}`}>
                    {job.status === 'completed' && <CheckCircle size={14} weight="bold" />}
                    {job.status === 'processing' && <SpinnerGap size={14} weight="bold" className="animate-spin" />}
                    {job.status || '-'}
                  </span>
                </td>
                <td className="py-2 pr-3">{job.progress ?? 0}%</td>
                <td className="py-2 pr-3">
                  {job.output?.downloadURL ? (
                    <button
                      type="button"
                      onClick={() => handleDownload(job)}
                      disabled={downloadingJobId === job.id}
                      className="inline-flex items-center gap-1 font-semibold text-brand-700 underline decoration-brand-300 underline-offset-4 disabled:opacity-60"
                    >
                      <DownloadSimple size={14} weight="bold" />
                      {downloadingJobId === job.id ? 'Downloading...' : 'Download'}
                    </button>
                  ) : (
                    '-'
                  )}
                </td>
                <td className="py-2 pr-3">
                  <div className="flex flex-col items-start gap-1">
                    <div className="grid w-max grid-cols-2 gap-2">
                      <button
                        type="button"
                        className="inline-flex items-center justify-center rounded-md bg-amber-100 p-2 text-amber-800 transition hover:bg-amber-200 disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={() => handleRetryClick(job)}
                        disabled={retryingJobId === job.id}
                        aria-label={retryingJobId === job.id ? 'Retrying job' : 'Retry job'}
                        title={retryingJobId === job.id ? 'Retrying' : 'Retry'}
                      >
                        <ArrowClockwise size={14} weight="bold" className={retryingJobId === job.id ? 'animate-spin' : ''} />
                      </button>
                      <button
                        type="button"
                        className="inline-flex items-center justify-center rounded-md bg-slate-100 p-2 text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={() => handleDeleteJob(job.id)}
                        disabled={deletingJobId === job.id}
                        aria-label={deletingJobId === job.id ? 'Deleting job' : 'Delete job'}
                        title={deletingJobId === job.id ? 'Deleting' : 'Delete'}
                      >
                        <Trash size={14} weight="bold" />
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
            {!jobs.length && (
              <tr>
                <td className="py-4 text-slate-500" colSpan={7}>
                  No jobs yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default JobsTable;
